import naja from 'naja';

export default class ContentFilterButton {
    static init(): void {
        this.FilterButtonInit();

        naja.snippetHandler.addEventListener('afterUpdate', (event) => {
            if (event.detail.snippet.id === 'snippet--filterCounter') {
                this.FilterButtonInit();
            }
        });
    }

    static FilterButtonInit(): void {
        // Najdeme potřebné elementy s null checkem
        const filterButton = document.querySelector('.js-content-filter-button') as HTMLElement | null;
        const categoryFilter = document.querySelector('.category-filter') as HTMLElement | null;

        // Pokud elementy neexistují, ukončíme funkci
        if (!filterButton || !categoryFilter) {
            return;
        }

        // Přidáme CSS transition do stylů category-filter
        categoryFilter.style.transition = 'height 0.3s ease-in-out';

        // Přidáme event listener na tlačítko
        filterButton.addEventListener('click', (e: Event) => {
            e.preventDefault(); // Zabrání výchozí akci linku

            this.toggleFilter(categoryFilter);
        });
    }

    private static toggleFilter(categoryFilter: HTMLElement): void {
        // Zkontrolujeme aktuální stav
        if (categoryFilter.style.height === '0px' || categoryFilter.style.height === '') {
            // Rozbalíme: nejprve změříme skutečnou výšku
            categoryFilter.style.height = 'auto';
            const actualHeight = categoryFilter.offsetHeight + 'px';
            categoryFilter.style.height = '0px';

            // Forcujeme reflow a pak nastavíme cílovou výšku
            categoryFilter.offsetHeight; // trigger reflow
            categoryFilter.style.height = actualHeight;
            categoryFilter.setAttribute('data-expanded', 'true');
        } else {
            // Sbalíme zpět na 0
            categoryFilter.style.height = '0px';
            categoryFilter.setAttribute('data-expanded', 'false');
        }
    }

    // Alternativní metoda s explicitním data-expanded checkem
    private static toggleCategoryFilterAlternative(categoryFilter: HTMLElement): void {
        const isExpanded = categoryFilter.getAttribute('data-expanded') === 'true';

        if (isExpanded) {
            // Sbalení
            categoryFilter.style.height = '0px';
            categoryFilter.setAttribute('data-expanded', 'false');
        } else {
            // Rozbalení
            categoryFilter.style.height = 'auto';
            const height = categoryFilter.offsetHeight + 'px';
            categoryFilter.style.height = '0px';
            categoryFilter.offsetHeight; // trigger reflow
            categoryFilter.style.height = height;
            categoryFilter.setAttribute('data-expanded', 'true');
        }
    }

    // Metoda pro manuální cleanup (pokud potřebuješ)
    static cleanup(): void {
        const filterButton = document.querySelector('.js-content-filter-button') as HTMLElement | null;

        if (filterButton) {
            // Odstraníme event listenery pokud by bylo potřeba
            filterButton.removeEventListener('click', this.FilterButtonInit);
        }
    }
}
